import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

type DevToolsState = {
  enableDevInformation: boolean;
  ptlSimulationEnabled: boolean;
};

export const initialState: DevToolsState = {
  enableDevInformation: false,
  ptlSimulationEnabled: false
};

export const devToolsSlice = createSlice({
  name: "devTools",
  initialState,
  reducers: {
    toggleDevInfomation(state, { payload }: PayloadAction<boolean>) {
      state.enableDevInformation = payload;
    },
    togglePtlSimulationEnabled(state) {
      state.ptlSimulationEnabled = !state.ptlSimulationEnabled;
    }
  },
  selectors: {
    selectEnableDevInformation: (state: DevToolsState) =>
      state.enableDevInformation,
    selectPtlSimulationEnabled: (state: DevToolsState) =>
      state.ptlSimulationEnabled
  }
});

export const { selectEnableDevInformation, selectPtlSimulationEnabled } =
  devToolsSlice.selectors;
export const { toggleDevInfomation, togglePtlSimulationEnabled } =
  devToolsSlice.actions;

const devToolsPersistConfig = {
  key: "devTools",
  storage,
  whitelist: ["enableDevInformation", "ptlSimulationEnabled"]
};

export const devToolsReducer = persistReducer(
  devToolsPersistConfig,
  devToolsSlice.reducer
);
